import { render, staticRenderFns } from "./HistoryChatDetail.vue?vue&type=template&id=71ec196e&scoped=true"
import script from "./HistoryChatDetail.vue?vue&type=script&lang=js"
export * from "./HistoryChatDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryChatDetail.vue?vue&type=style&index=0&id=71ec196e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec196e",
  null
  
)

export default component.exports